// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pix-form__note[data-v-2bfc659a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  gap: 0.45rem;\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n}[dir] .pix-form__note[data-v-2bfc659a] {\n  margin: 0;\n}\n", ""]);
// Exports
module.exports = exports;
